import { render, staticRenderFns } from "./open.vue?vue&type=template&id=0ff23764&scoped=true"
import script from "./open.vue?vue&type=script&lang=ts"
export * from "./open.vue?vue&type=script&lang=ts"
import style0 from "./open.vue?vue&type=style&index=0&id=0ff23764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff23764",
  null
  
)

export default component.exports